<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="firstName" id="firstName" type="text" pInputText>
            <label for="firstName">First Name</label>
            @for (validation of validationMessages.firstName; track validation) {
              <span>
                @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="lastName" id="lastName" type="text" pInputText>
            <label for="lastName">Last Name</label>
            @for (validation of validationMessages.lastName; track validation) {
              <span>
                @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="emailAddress" id="emailAddress" type="text" pInputText>
            <label for="emailAddress">Email</label>
            @for (validation of validationMessages.emailAddress; track validation) {
              <span>
                @if (form1.get('emailAddress').hasError(validation.type) && (form1.get('emailAddress').dirty || form1.get('emailAddress').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="mobilePhone" id="mobilePhone" type="text" pInputText>
            <label for="mobilePhone">Mobile</label>
            @for (validation of validationMessages.mobilePhone; track validation) {
              <span>
                @if (form1.get('mobilePhone').hasError(validation.type) && (form1.get('mobilePhone').dirty || form1.get('mobilePhone').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (guestMasterProfileId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!guestMasterProfileId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (guestMasterProfileId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>